import { createTopLevelAction } from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";
import { getColorOptionsLoadStatus, getMarkers } from "./selectors";
import ViewerMethod from "../../core/ViewerMethod";
import { createViewerAction } from "../../core/make-action";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { fetchHighlightsIfNeeded } from "../highlights/actions";

const fetchMarkers = createTopLevelAction(TopLevelMethod.GET_MARKERS);
export const addMarker = createTopLevelAction(TopLevelMethod.CREATE_MARKER);
const redrawHighlights = createViewerAction(ViewerMethod.REDRAW_HIGHLIGHTS);

export const deleteMarker = (syncId) => {
  return function (dispatch, getState) {
    const doDeleteMarker = createTopLevelAction(TopLevelMethod.DELETE_MARKER);
    if (getMarkers(getState()).length > 1) {
      return dispatch(doDeleteMarker(syncId)).then(({ ok }) => {
        if (ok) {
          return dispatch(redrawHighlights());
        }
        return { ok: false };
      });
    } else {
      return Promise.resolve({ ok: false });
    }
  };
};

/**
 * Do not load markers separately from highlights. The highlights response
 * contains information about the user's markers and we believe there is a
 * backend issue related to getMarkers and getHighlights trying to create markers
 * for new users in parallel, leading to too many markers. We need the highlight
 * list to build the gutter anyway.
 */
export const fetchMarkersIfNeeded = fetchHighlightsIfNeeded;

/**
 * However, we do still need the markers response in order to build the color
 * options in the marker management dialog. This should only be called at
 * point of use, so shouldn't cause the creation conflict we're trying to avoid.
 * If this fixes it, we should consider adding a color options only endpoint
 * to jigsaw and mosaic to avoid future timing problems.
 */
export const fetchColorOptionsIfNeeded = () => (dispatch, getState) => {
  if (getColorOptionsLoadStatus(getState()) === DetailedLoadStatus.WAITING) {
    return dispatch(fetchMarkers());
  }
  return Promise.resolve({ ok: true });
};

export const updateMarker = (markerId, dataFields) => {
  const doUpdateMarker = createTopLevelAction(TopLevelMethod.UPDATE_MARKER);
  return function (dispatch) {
    return dispatch(doUpdateMarker(markerId, dataFields)).then(({ ok }) => {
      if (ok) {
        return dispatch(redrawHighlights());
      }
      return { ok: false };
    });
  };
};
